import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import "./ImageViewer.css";

export default function ImageViewer({ images, initialIndex = 0, onClose, showCaption = true }) {
  const [index, setIndex] = useState(Math.max(0, Math.min(initialIndex, images.length - 1)));
  const [failed, setFailed] = useState(false);
  const dialog = useRef(null);
  const touchStart = useRef(null);
  const move = (delta) => { setIndex((current) => Math.max(0, Math.min(images.length - 1, current + delta))); };
  useEffect(() => {
    const previous = document.activeElement;
    const element = dialog.current;
    const overflow = document.body.style.overflow;
    element.showModal();
    document.body.style.overflow = "hidden";
    return () => { element.close(); document.body.style.overflow = overflow; previous?.focus(); };
  }, []);
  useEffect(() => { setFailed(false); }, [index]);
  const image = images[index];
  return <dialog ref={dialog} className="image-viewer" aria-label="Fullscreen image viewer" onCancel={(event) => { event.preventDefault(); event.stopPropagation(); onClose(); }} onKeyDown={(event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") { event.preventDefault(); event.stopPropagation(); move(event.key === "ArrowLeft" ? -1 : 1); }
  }}>
    <div className="image-viewer-toolbar"><span aria-live="polite">{index + 1} / {images.length}</span><button type="button" aria-label="Close image viewer" onClick={onClose} autoFocus><X size={24} /></button></div>
    <div className="image-viewer-stage" onTouchStart={(event) => { const touch = event.touches[0]; touchStart.current = { x: touch.clientX, y: touch.clientY }; }} onTouchEnd={(event) => {
      const start = touchStart.current; touchStart.current = null;
      if (!start || event.changedTouches.length !== 1) return;
      const touch = event.changedTouches[0], dx = start.x - touch.clientX, dy = start.y - touch.clientY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) move(dx > 0 ? 1 : -1);
    }}>
      {images.length > 1 && <button type="button" className="image-viewer-previous" aria-label="Previous image" disabled={index === 0} onClick={() => move(-1)}><ChevronLeft size={28} /></button>}
      {failed ? <p role="alert">This image could not be loaded.</p> : image && <img key={image.imageUrl} src={image.imageUrl} alt={image.title || "Project photo " + (index + 1)} onError={() => setFailed(true)} />}
      {images.length > 1 && <button type="button" className="image-viewer-next" aria-label="Next image" disabled={index === images.length - 1} onClick={() => move(1)}><ChevronRight size={28} /></button>}
    </div>{showCaption && <div className="image-viewer-caption">{image?.title || "Project photo " + (index + 1)}</div>}
  </dialog>;
}
